var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-space-between align-center mb-3" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                outlined: "",
                small: "",
                disabled: !_vm.data || _vm.data.length === 0,
              },
              on: { click: _vm.downloadCSV },
            },
            [
              _c("v-icon", { attrs: { left: "", small: "" } }, [
                _vm._v("mdi-download"),
              ]),
              _vm._v(" Download CSV "),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "mt-4 mb-8 text-caption text--secondary" }, [
        _vm.currentUpperLimit !== undefined ||
        _vm.currentLowerLimit !== undefined
          ? _c(
              "div",
              [
                _c("strong", [_vm._v("Violation limits:")]),
                _vm.currentUpperLimit !== undefined
                  ? _c(
                      "span",
                      [
                        _vm._v(" Upper limit: "),
                        _c("v-text-field", {
                          staticStyle: {
                            width: "80px",
                            display: "inline-block",
                            margin: "0 4px",
                          },
                          attrs: {
                            type: "number",
                            step: "0.01",
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.currentUpperLimit,
                            callback: function ($$v) {
                              _vm.currentUpperLimit = _vm._n($$v)
                            },
                            expression: "currentUpperLimit",
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.units) + " "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentUpperLimit !== undefined &&
                _vm.currentLowerLimit !== undefined
                  ? _c("span", [_vm._v(" • ")])
                  : _vm._e(),
                _vm.currentLowerLimit !== undefined
                  ? _c(
                      "span",
                      [
                        _vm._v(" Lower limit: "),
                        _c("v-text-field", {
                          staticStyle: {
                            width: "80px",
                            display: "inline-block",
                            margin: "0 4px",
                          },
                          attrs: {
                            type: "number",
                            step: "0.01",
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.currentLowerLimit,
                            callback: function ($$v) {
                              _vm.currentLowerLimit = _vm._n($$v)
                            },
                            expression: "currentLowerLimit",
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.units) + " "),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-tooltip",
                  {
                    attrs: { top: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  { attrs: { color: "warning", icon: "" } },
                                  on
                                ),
                                [_vm._v("mdi-alert-circle")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1539900414
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "Note: Changing limits here won't affect contingency analysis results. To do that, change in case settings and re-run the case."
                      ),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "mt-1" },
          [
            _vm._v(" Values in "),
            _c(
              "v-chip",
              { attrs: { color: "deep-orange", dark: "", "x-small": "" } },
              [_vm._v("orange")]
            ),
            _vm._v(" exceed the violation limits. "),
          ],
          1
        ),
      ]),
      _c(
        "v-data-table",
        _vm._g(
          _vm._b(
            {
              attrs: { headers: _vm.headers, items: _vm.sortedData },
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm.dataColumns, function (column) {
                    return {
                      key: "item." + column.key,
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _vm.isViolation(item[column.key])
                            ? _c(
                                "v-chip",
                                {
                                  key: column.key,
                                  attrs: {
                                    color: "deep-orange",
                                    dark: "",
                                    small: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatNumber(item[column.key])
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _c("span", { key: column.key }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatNumber(item[column.key])) +
                                    " "
                                ),
                              ]),
                        ]
                      },
                    }
                  }),
                ],
                null,
                true
              ),
            },
            "v-data-table",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }